/* ============================================================
   LOF Story – section-lof-story.js
   Drop this file in /assets/

   Defines <lof-story-slider>, a small custom element that makes
   the image strip in section-lof-story.liquid draggable with a
   mouse (click + drag) in addition to the native touch/trackpad
   swipe you already get for free from overflow-x + scroll-snap.

   Kept dependency-free and separate from Dawn's slider-component
   because that component drives fixed-width, button-controlled
   slideshows — this is a free-drag "peek" carousel with no arrows.
   ============================================================ */
(function () {
  if (customElements.get('lof-story-slider')) return;

  class LofStorySlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-lof-story-track]');
      if (!this.track) return;

      this.isPointerDown = false;
      this.hasDragged = false;
      this.startX = 0;
      this.startScrollLeft = 0;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onClickCapture = this.onClickCapture.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      this.track.addEventListener('pointerdown', this.onPointerDown);
      this.track.addEventListener('pointermove', this.onPointerMove);
      this.track.addEventListener('pointerup', this.onPointerUp);
      this.track.addEventListener('pointercancel', this.onPointerUp);
      this.track.addEventListener('pointerleave', this.onPointerUp);
      this.track.addEventListener('click', this.onClickCapture, true);
      this.track.addEventListener('keydown', this.onKeyDown);

      // Prevent the browser's native image/link drag ghost.
      this.track.addEventListener('dragstart', (event) => event.preventDefault());
    }

    onPointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      this.isPointerDown = true;
      this.hasDragged = false;
      this.startX = event.clientX;
      this.startScrollLeft = this.track.scrollLeft;
      this.track.classList.add('is-dragging');
      if (this.track.setPointerCapture) {
        try {
          this.track.setPointerCapture(event.pointerId);
        } catch (e) {
          /* no-op: some browsers throw if the pointer already released */
        }
      }
    }

    onPointerMove(event) {
      if (!this.isPointerDown) return;
      const delta = event.clientX - this.startX;
      if (Math.abs(delta) > 4) this.hasDragged = true;
      this.track.scrollLeft = this.startScrollLeft - delta;
    }

    onPointerUp() {
      if (!this.isPointerDown) return;
      this.isPointerDown = false;
      this.track.classList.remove('is-dragging');
    }

    // Swallow the click that follows a drag so a slide's link (if any)
    // doesn't accidentally fire when the visitor was just dragging.
    onClickCapture(event) {
      if (this.hasDragged) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.hasDragged = false;
    }

    onKeyDown(event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const firstSlide = this.track.querySelector('.lof-story__slide');
      if (!firstSlide) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
      const amount = firstSlide.getBoundingClientRect().width + gap;
      this.track.scrollBy({
        left: event.key === 'ArrowRight' ? amount : -amount,
        behavior: 'smooth',
      });
    }
  }

  customElements.define('lof-story-slider', LofStorySlider);
})();
